import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Regexs } from '@utils/regex';

@Component({
  selector: 'app-datos-filiatorios',
  templateUrl: './datos-filiatorios.component.html',
  styleUrls: ['./datos-filiatorios.component.scss'],
})
export class DatosFiliatoriosComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      descripcion: [values ? values.descripcion : ''],
      nombre_empresa: [values ? values.nombre_empresa : ''],
      rif: [
        values ? values.rif : '',
        [Validators.required, Validators.pattern(Regexs.regexCiRif)],
      ],
      tipo_persona: [values ? values.tipo_persona : ''],
      razon_social: [values ? values.razon_social : ''],
      cedula: [
        values ? values.cedula : '',
        [Validators.required, Validators.pattern(Regexs.regexCiRif)],
      ],
      nombre: [values ? values.nombre : ''],
      telefono: [
        values ? values.telefono : '',
        [Validators.required, Validators.pattern(Regexs.regexPhoneNumber)],
      ],
      direccion: [values ? values.direccion : ''],
      direccion_laboral: [values ? values.direccion_laboral : ''],
      otras_direcciones_BDV: [values ? values.otras_direcciones_BDV : ''],
      oficina_tutora: [values ? values.oficina_tutora : ''],
      cuentas_BDV: [
        values ? values.cuentas_BDV : '',
        [Validators.pattern(Regexs.regexAccountNumber)],
      ],
      saldo: [
        values ? values.saldo : '',
        [Validators.required, Validators.pattern(Regexs.regexAmount)],
      ],
      correo: [
        values ? values.correo : '',
        [Validators.required, Validators.pattern(Regexs.EMAIL_REGEX)],
      ],
      referencia_personal_BDV: [values ? values.referencia_personal_BDV : ''],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
